import { FaClipboardList } from 'react-icons/fa6'
import { inProgressIcon, pendingIcon, resolvedIcon } from '../../utils/svgs'

const ActiveWorkOrder = ({ workOrderData }) => {
    return (
        <div className="work-orders-widget">
            <div className="widget-title">
                <FaClipboardList color='#4F19E2' />
                Active Work Orders
            </div>
            <div className="order-list">
                <div className="order-item">
                    <div className="order-label">
                        {resolvedIcon}
                        <span className="status completed" style={{fontSize: "18px"}}>Completed</span>
                    </div>
                    <span className="status-count blue-bg">{workOrderData?.completed}</span>
                </div>
                <div className="order-item">
                    <div className="order-label">
                        {inProgressIcon}
                        <span className="status in_progress" style={{fontSize: "18px"}}>In Progress</span>
                    </div>
                    <span className="status-count yellow-bg">{workOrderData?.in_progress}</span>
                </div>
                <div className="order-item">
                    <div className="order-label">
                        {resolvedIcon}
                        <span className="status approved" style={{fontSize: "18px"}}>Approved</span>
                    </div>
                    <span className="status-count blue-bg">{workOrderData?.approved}</span>
                </div>
                <div className="order-item">
                    <div className="order-label">
                        {pendingIcon}
                        <span className="status pending" style={{fontSize: "18px"}}>Pending</span>
                    </div>
                    <span className="status-count red-bg">{workOrderData?.pending}</span>
                </div>
            </div>
        </div>
    )
}

export default ActiveWorkOrder